import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { StepProps } from '../../types';

const Container = styled.div`
  ${tw`flex flex-col h-full`}
`;

const SectionLabel = styled.div`
  ${tw`text-xs font-semibold text-text-secondary uppercase tracking-wider mb-3`}
`;

const Title = styled.h2`
  ${tw`text-xl font-semibold text-text-primary mb-6`}
`;

const Textarea = styled.textarea`
  ${tw`w-full p-4 border border-border-default rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent resize-none`}
  min-height: 150px;
`;

const CharCount = styled.div`
  ${tw`text-right text-sm text-text-secondary mt-2 mb-4`}
`;

const ContinueButton = styled.button`
  ${tw`w-full py-4 font-semibold rounded-card mt-auto bg-black text-white hover:bg-black-hover`}
`;

interface AdditionalInfoStepProps extends StepProps {
  isLastStep?: boolean;
}

const MAX_LENGTH = 1000;

const AdditionalInfoStep: React.FC<AdditionalInfoStepProps> = ({
  formData,
  updateFormData,
  onNext,
  isLastStep = false,
  isSubmitting,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value.slice(0, MAX_LENGTH);
    updateFormData({ additionalInfo: value });
  };

  const charCount = formData.additionalInfo?.length || 0;

  return (
    <Container>
      <SectionLabel>ADDITIONAL INFORMATION</SectionLabel>
      <Title>Is there any additional information you'd like to add?</Title>

      <Textarea
        placeholder="Add any other details that might help with the claim..."
        value={formData.additionalInfo || ''}
        onChange={handleChange}
        maxLength={MAX_LENGTH}
      />
      <CharCount>
        {charCount}/{MAX_LENGTH}
      </CharCount>

      <ContinueButton onClick={onNext} disabled={!!isSubmitting}>
        {isSubmitting ? 'Submitting...' : isLastStep ? 'Submit claim' : 'Continue'}
      </ContinueButton>
    </Container>
  );
};

export default AdditionalInfoStep;
